import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';
import { ShieldHeartIcon, DropletIcon, LeafIcon, SparkIcon } from './icons/Icons';
const STOMACH = 'https://cdn.magicpatterns.com/patterns/generated-images/00bfc325-8c07-4111-8830-257b9ce41a8b.jpg';
const pillars = [{
  icon: LeafIcon,
  title: '3 Mucílagos Naturales',
  desc: 'Forman una venda líquida que recubre y protege la pared del estómago.'
}, {
  icon: DropletIcon,
  title: 'Jugo rico en “Vitamina U”',
  desc: 'El compuesto específico que ayuda a regenerar la mucosa desde adentro.'
}, {
  icon: ShieldHeartIcon,
  title: 'Tu escudo protector',
  desc: 'Tu estómago sana mientras tú sigues viviendo tu vida normal.'
}];
export function RevelationSection() {
  return <section className="w-full bg-[#eef2e6] py-16 sm:py-20" data-id="element-219">
      <div className="mx-auto max-w-6xl px-5" data-id="element-220">
        <div className="grid items-center gap-10 lg:grid-cols-2" data-id="element-221">
          <div data-id="element-222">
            <Reveal data-id="element-223">
              <span className="inline-flex items-center gap-2 rounded-full bg-[#3f6b3a] px-4 py-1.5 text-xs font-semibold uppercase tracking-wide text-white" data-id="element-224">
                <SparkIcon className="h-4 w-4" strokeWidth={2.2} data-id="element-225" />
                La Revelación · Ciencia 2026
              </span>
            </Reveal>

            <Reveal delay={0.08} data-id="element-226">
              <h2 className="mt-5 font-display text-3xl font-extrabold leading-tight text-[#1f2a22] sm:text-4xl" data-id="element-227">
                El alivio real no viene de{' '}
                <span className="text-[#7a1e12]" data-id="element-228">“quitar el ácido”</span>… viene
                de <span className="text-[#3f6b3a]" data-id="element-229">regenerar la mucosa.</span>
              </h2>
            </Reveal>

            <Reveal delay={0.16} data-id="element-230">
              <p className="mt-5 text-lg leading-relaxed text-[#3d4a40]" data-id="element-231">
                Tu estómago necesita su escudo protector de vuelta. Descubrí que
                combinando 3 mucílagos naturales y un jugo específico rico en
                “Vitamina U” puedes crear una{' '}
                <span className="font-semibold text-[#1f2a22]" data-id="element-232">
                  venda líquida
                </span>{' '}
                que permite que tu estómago sane mientras tú sigues viviendo. Lo
                llamé el{' '}
                <span className="font-display font-bold text-[#3f6b3a]" data-id="element-233">
                  Método GastroSmart.
                </span>
              </p>
            </Reveal>

            <div className="mt-8 space-y-3" data-id="element-234">
              {pillars.map((p, i) => <Reveal key={p.title} delay={0.2 + i * 0.08} data-id="element-235">
                  <div className="flex items-start gap-4 rounded-xl bg-white p-4 shadow-sm" data-id="element-236">
                    <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#3f6b3a]/10 text-[#3f6b3a]" data-id="element-237">
                      <p.icon className="h-6 w-6" strokeWidth={2} data-id="element-238" />
                    </span>
                    <div data-id="element-239">
                      <h3 className="font-display text-base font-bold text-[#1f2a22]" data-id="element-240">
                        {p.title}
                      </h3>
                      <p className="mt-0.5 text-sm text-[#5a6b5c]" data-id="element-241">{p.desc}</p>
                    </div>
                  </div>
                </Reveal>)}
            </div>
          </div>

          <Reveal delay={0.24} className="flex justify-center" data-id="element-242">
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 5,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative" data-id="element-243">
              <motion.div className="absolute -inset-4 rounded-full bg-[#3f6b3a]/20 blur-2xl" animate={{
              opacity: [0.4, 0.75, 0.4]
            }} transition={{
              duration: 3,
              repeat: Infinity,
              ease: 'easeInOut'
            }} aria-hidden="true" data-id="element-244" />
              <img src={STOMACH} alt="Ilustración de un estómago sano con su mucosa protectora regenerada" className="relative w-72 rounded-3xl shadow-xl sm:w-80" data-id="element-245" />
            </motion.div>
          </Reveal>
        </div>
      </div>
    </section>;
}